import { Segment, SegmentedButton } from '~/shared/ui'
import { useFilters } from '../../../model'

export function FlaggedFilter() {
  const { filters, setFilters } = useFilters()

  return (
    <SegmentedButton
      className="block px-4 py-2"
      size="small"
    >
      <Segment
        checked={filters.flagged === 'not_flagged'}
        onClick={() => setFilters({ flagged: 'not_flagged' })}
      >
        UNFLAGGED
      </Segment>
      <Segment
        checked={filters.flagged === 'flagged'}
        onClick={() => setFilters({ flagged: 'flagged' })}
      >
        FLAGGED
      </Segment>
    </SegmentedButton>
  )
}
